



















import { Component, Prop, Vue } from 'vue-property-decorator'
import Notifications from '@/components/Notifications.vue'

@Component({
    components: {
        Notifications,
    },
})
export default class NotificationsBloc extends Vue {
    filter: string = 'all'
}
